import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from'../Component/Header';
import Footer from'../Component/Footer';
import LazyLoad from 'react-lazyload';
const QuestClub = () => {
    useEffect(() => {
        document.title = 'Quest Club -  Sacred Heart School, Ballia - U.P.';  
    }, []); 
   return (
        <>
        <Header/>
            <section className="page-header"> 
                    <div className="page-header__inner">
                    <h2>Quest Club </h2>
                        <ul className="thm-breadcrumb list-unstyled ml-0">
                            <li><Link to="/"> Home</Link></li> 
                            <li>|</li>
                            <li> Quest Club </li>
                        </ul> 
                </div>
            </section>
            <section className="innerbody">
               <div className='container'> 
                <div className="row sports"> 
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                     <LazyLoad>
                        <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SHSSB/public/Images/quest-club1.jpg">
                            <img src="https://webapi.entab.info/api/image/SHSSB/public/Images/quest-club1.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
                    </a>
                </LazyLoad>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                     <LazyLoad>
                        <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SHSSB/public/Images/quest-club2.jpg">
                            <img src="https://webapi.entab.info/api/image/SHSSB/public/Images/quest-club2.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
                    </a>
                </LazyLoad>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                     <LazyLoad>
                        <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SHSSB/public/Images/quest-club3.jpg">
                            <img src="https://webapi.entab.info/api/image/SHSSB/public/Images/quest-club3.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
                    </a>
                </LazyLoad>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                     <LazyLoad>
                        <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SHSSB/public/Images/quest-club4.jpg">
                            <img src="https://webapi.entab.info/api/image/SHSSB/public/Images/quest-club4.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
                    </a>
                </LazyLoad>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                     <LazyLoad>
                        <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SHSSB/public/Images/quest-club5.jpg">
                            <img src="https://webapi.entab.info/api/image/SHSSB/public/Images/quest-club5.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
                    </a>
                </LazyLoad>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                     <LazyLoad>
                        <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SHSSB/public/Images/quest-club6.jpg">
                            <img src="https://webapi.entab.info/api/image/SHSSB/public/Images/quest-club6.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
                    </a>
                </LazyLoad>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                     <LazyLoad>
                        <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SHSSB/public/Images/quest-club7.jpg">
                            <img src="https://webapi.entab.info/api/image/SHSSB/public/Images/quest-club7.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
                    </a>
                </LazyLoad>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                <LazyLoad>
                   <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SHSSB/public/Images/quest-club8.jpg">
                       <img src="https://webapi.entab.info/api/image/SHSSB/public/Images/quest-club8.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
               </a>
           </LazyLoad>
           </div>
           <div className="col-xl-3 col-lg-4 col-md-6 col-12">
           <LazyLoad>
              <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SHSSB/public/Images/quest-club9.jpg">
                  <img src="https://webapi.entab.info/api/image/SHSSB/public/Images/quest-club9.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
          </a>
      </LazyLoad>
      </div> <div className="col-xl-3 col-lg-4 col-md-6 col-12">
      <LazyLoad>
         <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SHSSB/public/Images/quest-club10.jpg">
             <img src="https://webapi.entab.info/api/image/SHSSB/public/Images/quest-club10.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
     </a>
 </LazyLoad>
 </div>
 <div className="col-xl-3 col-lg-4 col-md-6 col-12">
 <LazyLoad>
    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SHSSB/public/Images/quest-club11.jpg">
        <img src="https://webapi.entab.info/api/image/SHSSB/public/Images/quest-club11.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
</a>
</LazyLoad>
</div>
<div className="col-xl-3 col-lg-4 col-md-6 col-12">
<LazyLoad>
   <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SHSSB/public/Images/quest-club12.jpg">
       <img src="https://webapi.entab.info/api/image/SHSSB/public/Images/quest-club12.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
</a>
</LazyLoad>
</div>
<div className="col-xl-3 col-lg-4 col-md-6 col-12">
<LazyLoad>
   <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SHSSB/public/Images/quest-club13.jpg">
       <img src="https://webapi.entab.info/api/image/SHSSB/public/Images/quest-club13.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
</a>
</LazyLoad>
</div>
<div className="col-xl-3 col-lg-4 col-md-6 col-12">
<LazyLoad>
   <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SHSSB/public/Images/quest-club14.jpg">
       <img src="https://webapi.entab.info/api/image/SHSSB/public/Images/quest-club14.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
</a>
</LazyLoad>
</div>
<div className="col-xl-3 col-lg-4 col-md-6 col-12">
<LazyLoad>
   <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SHSSB/public/Images/quest-club15.jpg">
       <img src="https://webapi.entab.info/api/image/SHSSB/public/Images/quest-club15.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
</a>
</LazyLoad>
</div>
 
            </div>
               </div>
             </section>
            <Footer/>
        </>
    )
}

export default QuestClub